import React from 'react'
import './skill-tag.css';


const SkillTag = ({tag}) => {
	return (
		<div className='skill-tag-container'>
			{tag}
		</div>
	)
}

export default SkillTag